import { createContext, useContext, ParentComponent } from "solid-js";
import { DenominationGridState } from "~/hooks/denominations_grid/useDenominationsGrid";

const DenominationGridContext = createContext<DenominationGridState>();

export const DenominationGridProvider: ParentComponent<{
  value: DenominationGridState;
}> = (props) => {
  return (
    <DenominationGridContext.Provider value={props.value}>
      {props.children}
    </DenominationGridContext.Provider>
  );
};

export const useDenominationGridContext = () => {
  const context = useContext(DenominationGridContext);
  if (!context) {
    throw new Error(
      "useDenominationGridContext must be used within a DenominationGridProvider"
    );
  }
  return context;
};
